import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';

import { ReactComponent as AttachmentIcon } from '../../../../assets/icons/attachment-icon.svg';
import { ReactComponent as MicIcon } from '../../../../assets/icons/mic-icon.svg';
import colors from '../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  min-height: 50vh;
  width: 100%;
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  padding: 15px 13px;
  border-radius: 5px;
  border: 1px solid ${colors.shades.secondary7};
  margin-bottom: 12px;
`;

const baseTextCss = css`
  font-size: 14px;
  text-align: left;
`;

const MessageText = styled.div`
  ${baseTextCss};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 40vw;
`;

const MessageDate = styled.div`
  ${baseTextCss};
  flex-shrink: 0;
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
`;

const EditContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
`;

const InfoText = styled.div`
  ${baseTextCss};
  width: 100%;
`;

const FileAttachmentIcon = styled(AttachmentIcon)`
  display: block;
  height: 22px;
  width: 20px;

  > path {
    fill: transparent;
    stroke: ${colors.base.primary};
    stroke-width: 1.2;
  }
`;

const StyledMicIcon = styled(MicIcon)`
  display: block;
  width: 20px;
  height: 20px;
  color: ${colors.base.primary};
`;

const SubText = styled.div`
  font-size: 12px;
`;

const Title = styled(Typography)`
  text-align: center;
  font-weight: 500;
  margin-bottom: 10px;
`;

export {
  Container,
  ItemContainer,
  MessageText,
  MessageDate,
  ActionsContainer,
  InfoContainer,
  EditContainer,
  InfoText,
  FileAttachmentIcon,
  StyledMicIcon,
  SubText,
  Wrapper,
  OuterContainer,
  Title,
};
